/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertNotificationSetting } from '../../models/alert-notification-setting';
import { NotificationTitle } from '../../models/notification-title';

export interface GetSettingsByTitleRoleId_1$Params {
  roleId: number;
  title: NotificationTitle;
}

export function getSettingsByTitleRoleId_1(http: HttpClient, rootUrl: string, params: GetSettingsByTitleRoleId_1$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, getSettingsByTitleRoleId_1.PATH, 'get');
  if (params) {
    rb.path('roleId', params.roleId, {});
    rb.path('title', params.title, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlertNotificationSetting>;
    })
  );
}

getSettingsByTitleRoleId_1.PATH = '/api/notification/alert/setting/title/{title}/roleId/{roleId}';
